import { Table } from 'semantic-ui-react';
import { useTable } from 'react-table';
import TableStyles from './TableStyles';

function BasicTable({ columns, data, hidden_columns = [] }) {
	const {
		getTableProps,
		getTableBodyProps,
		headerGroups,
		rows,
		prepareRow,
	} = useTable({
		columns,
		data,
		initialState : { hiddenColumns : hidden_columns }
	});

	return (
		<TableStyles>
			<Table striped celled {...getTableProps()}>
				<thead>
					{headerGroups.map((headerGroup, i) => (
						<tr {...headerGroup.getHeaderGroupProps} key={i}>
							{headerGroup.headers.map(column => (
								<th {...column.getHeaderProps()}>{column.render('Header')}</th>
							))}
						</tr>
					))}
				</thead>

				<Table.Body {...getTableBodyProps()}>
					{rows.map((row, i) => {
						prepareRow(row)

						return (
							<tr {...row.getRowProps()} key={i}>
								{row.cells.map(cell => {
									return <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
								})}
							</tr>
						)
					})}
				</Table.Body>
			</Table>
		</TableStyles>
	);
}

export default BasicTable;
